import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import DateRange from '@material-ui/icons/DateRange';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Help from '@material-ui/icons/Help';
import Home from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Menu';
import Message from '@material-ui/icons/Message';
import Receipt from '@material-ui/icons/Receipt';
import Search from '@material-ui/icons/Search';
import Settings from '@material-ui/icons/Settings';
import Star from '@material-ui/icons/Star';
import ListIcon from '@material-ui/icons/List';
import { grey } from '@material-ui/core/colors';
import {
  withStyles,
  AppBar,
  Divider,
  Drawer,
  Hidden,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Toolbar,
  Typography,
  Chip,
} from '@material-ui/core';
import {
  todos as todoSelector,
} from 'selectors/user';
import PATHS from 'constants/paths';

const drawerWidth = 300;
const styles = (theme) => ({
  root: {
    width: '100%',
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    position: 'fixed',
    backgroundColor: theme.palette.beige[75],
    marginLeft: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },

    '@media print': {
      display: 'none',
    },
  },
  appBarHideDrawer: {
    marginLeft: 0,
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
  },
  content: {
    flex: '100%',
    marginTop: 56,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      marginTop: 64,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: drawerWidth,
    },

    maxWidth: '100%',
  },
  contentHideDrawer: {
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
    },
  },
  drawerHeader: {
    ...theme.mixins.toolbar,
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(4),
    },
  },
  drawerHeaderHideDrawer: {
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(2),
    },
  },
  drawerPaper: {
    position: 'fixed',
    width: drawerWidth,
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      height: '100vh',
    },
    zIndex: 1501,
  },
  drawerPaperHideDrawer: {
    [theme.breakpoints.up('md')]: {
      position: 'fixed',
    },
  },
  drawerRoot: {
    zIndex: '1306 !important',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  title: {
    overflow: 'hidden',
    maxHeight: 48,
    color: theme.palette.beige.contrastText,
  },
  logo: {
    color: grey[800],
    fontWeight: 400,

    [theme.breakpoints.up('md')]: {
      marginLeft: '65px',
    },
  },
  mdDrawer: {
    position: 'fixed',
    zIndex: 1,
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
});

class Main extends React.Component {
  state = {
    mobileOpen: false,
  };

  componentDidMount() {
    if (document.body.style.overflow) {
      document.body.style.overflow = '';
    }
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  render() {
    const {
      children,
      classes,
      extra,
      hideDrawer,
      title,
      todos,
    } = this.props;

    const pendingTodos = (todos || []).filter((t) => !t.value || !t.value.read);

    const drawer = (
      <div>
        <div className={
          classNames(
            classes.drawerHeader,
            hideDrawer && classes.drawerHeaderHideDrawer,
          )
}
        >
          <IconButton
            aria-label="Close drawer"
            onClick={this.handleDrawerToggle}
            className={classNames(!hideDrawer && classes.navIconHide)}
          >
            <MenuIcon />
          </IconButton>
          <img
            src="data:image/png;base64,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"
            className={classes.logo}
            alt="Stugknuten.com"
            style={{ width: 100, height: 33 }}
          />
        </div>
        <Divider />
        <MenuList>
          <MenuItem
            divider
            component="a"
            href="/"
          >
            <ListItemIcon className={classes.icon}>
              <Search />
            </ListItemIcon>
            <ListItemText
              primary={(
                <FormattedMessage
                  id="main.find"
                  defaultMessage="Back to the main page"
                />
              )}
            />
          </MenuItem>
          <MenuItem
            divider
            component={Link}
            to="/to-do"
            onClick={this.menuClose}
          >
            <ListItemIcon className={classes.icon}>
              <ListIcon />
            </ListItemIcon>
            <ListItemText
              primary={(
                <>
                  <FormattedMessage
                    id="main.todo"
                    defaultMessage="To do list"
                  />
                  {
                    pendingTodos && !!pendingTodos.length && (
                      <div style={{ float: 'right' }}>
                        <Chip label={pendingTodos.length} color="secondary" size="small" />
                      </div>
                    )
                  }
                </>
              )}
            />
          </MenuItem>
          <MenuItem
            component={Link}
            to="/conversations"
            onClick={this.menuClose}
          >
            <ListItemIcon className={classes.icon}>
              <Message />
            </ListItemIcon>
            <ListItemText
              primary={(
                <FormattedMessage
                  id="main.myMessages"
                  defaultMessage="My messages"
                />
              )}
            />
          </MenuItem>
          <MenuItem
            component={Link}
            to="/bookings"
            onClick={this.menuClose}
          >
            <ListItemIcon className={classes.icon}>
              <DateRange />
            </ListItemIcon>
            <ListItemText
              primary={(
                <FormattedMessage
                  id="main.myBookings"
                  defaultMessage="My bookings"
                />
              )}
            />
          </MenuItem>
          <MenuItem
            component={Link}
            to="/cottages"
            onClick={this.menuClose}
          >
            <ListItemIcon className={classes.icon}>
              <Home />
            </ListItemIcon>
            <ListItemText
              primary={(
                <FormattedMessage
                  id="main.myListings"
                  defaultMessage="My listings"
                />
              )}
            />
          </MenuItem>
          <MenuItem
            component={Link}
            to={PATHS.reviews.root}
            onClick={this.menuClose}
          >
            <ListItemIcon className={classes.icon}>
              <Star />
            </ListItemIcon>
            <ListItemText
              primary={(
                <FormattedMessage
                  id="main.myReviews"
                  defaultMessage="My reviews"
                />
              )}
            />
          </MenuItem>
          <MenuItem
            divider
            component={Link}
            to="/orders"
            onClick={this.menuClose}
          >
            <ListItemIcon className={classes.icon}>
              <Receipt />
            </ListItemIcon>
            <ListItemText
              primary={(
                <FormattedMessage
                  id="main.myReceipts"
                  defaultMessage="My receipts"
                />
              )}
            />
          </MenuItem>
          <MenuItem
            component={Link}
            to={PATHS.users.profile}
            onClick={this.menuClose}
          >
            <ListItemIcon className={classes.icon}>
              <Settings />
            </ListItemIcon>
            <ListItemText
              primary={(
                <FormattedMessage
                  id="main.myProfile"
                  defaultMessage="My profile"
                />
              )}
            />
          </MenuItem>
          <MenuItem component={Link} to="/logout">
            <ListItemIcon className={classes.icon}>
              <ExitToApp />
            </ListItemIcon>
            <ListItemText
              primary={(
                <FormattedMessage
                  id="Logout"
                  defaultMessage="Logout"
                />
              )}
            />
          </MenuItem>
        </MenuList>
      </div>
    );

    return (
      <div className={classes.root}>
        <div className={classes.appFrame}>
          <AppBar className={classNames(classes.appBar, hideDrawer && classes.appBarHideDrawer)}>
            <Toolbar>
              <IconButton
                aria-label="Open drawer"
                onClick={this.handleDrawerToggle}
                className={classNames(!hideDrawer && classes.navIconHide)}
              >
                <MenuIcon />
              </IconButton>
              <div className={classes.flex}>
                <Typography
                  variant="subtitle1"
                  className={classes.title}
                >
                  {title}
                </Typography>
                <span>
                  {extra}
                </span>
              </div>
              {window.supportHeroWidget && (
                <IconButton
                  aria-label="Help"
                  onClick={window.supportHeroWidget.show}
                >
                  <Help />
                </IconButton>
              )}
            </Toolbar>
          </AppBar>
          <Hidden mdUp={!hideDrawer}>
            <Drawer
              variant="temporary"
              open={this.state.mobileOpen}
              classes={{
                docked: classNames(hideDrawer && classes.mdDrawer),
                paper: classNames(
                  classes.drawerPaper,
                  hideDrawer && classes.drawerPaperHideDrawer,
                ),
                root: classes.drawerRoot,
              }}
              onClose={this.handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          {!hideDrawer && (
            <Hidden smDown implementation="css">
              <Drawer
                variant="permanent"
                open
                classes={{
                  docked: classes.mdDrawer,
                  paper: classes.drawerPaper,
                }}
              >
                {drawer}
              </Drawer>
            </Hidden>
          )}
          <main className={classNames(classes.content, hideDrawer && classes.contentHideDrawer)}>
            {children}
          </main>
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({}).isRequired,
  hideDrawer: PropTypes.bool,
  extra: PropTypes.node,
  title: PropTypes.node,
  todos: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
    }),
  ),
};

const mapStateToProps = (state) => ({
  todos: todoSelector(state),
});

export default withStyles(styles)(connect(mapStateToProps)(Main));
